import { Box, Flex } from '@indoqa/style-system';
import * as React from 'react';
import { ColorsPanel } from '../colors/ColorsPanel';
import { FontMixContent } from '../typography/FontMixContent';
import { withUIETheme } from '../uietheme/withUIETheme';
const uniqueColors = (colors) => {
    const colorsMap = new Map();
    colors.forEach((color) => {
        const { hexCode } = color;
        if (hexCode) {
            colorsMap.set(hexCode, color);
        }
    });
    const result = [];
    colorsMap.forEach((color) => {
        result.push(color);
    });
    return result;
};
const OverviewPanelInternal = ({ fontMixes, fontSizes, textFontSize, colors, uieTheme }) => {
    const panelStyle = {
        marginTop: uieTheme.spacing.space4,
    };
    const textFont = fontMixes[0].textFont;
    const headlineFont = fontMixes[0].headlineFont;
    return (React.createElement(Flex, { fullWidth: true, direction: "column" },
        React.createElement(Box, null,
            React.createElement(Box, null,
                React.createElement(ColorsPanel, { colors: uniqueColors(colors), small: true })),
            React.createElement(Box, { style: panelStyle },
                React.createElement(FontMixContent, { textFont: textFont, headlineFont: headlineFont, fontSizes: fontSizes, textFontSize: textFontSize })))));
};
export const OverviewPanel = withUIETheme(OverviewPanelInternal);
//# sourceMappingURL=OverviewPanel.js.map